<script lang="ts" setup name="ContactCard">
import BaseItem from '~/components/BaseItem.vue';
import Icon from '~/components/Icon.vue';

const {
  title = '',
  linkUrl = '',
  linkText = '',
  loading,
} = defineProps<{
  title?: string;
  linkUrl?: string;
  linkText?: string;
  loading?: boolean;
  contacts?: Array<{
    id: string;
    label: string;
    value: string;
  }>;
}>();
</script>

<template>
  <div class="rounded-md bg-white p-6 shadow" data-test="contact-card">
    <div class="flex items-center justify-between">
      <p class="text-subtitle-1 text-charcoal-9">{{ title }}</p>
      <Icon icon="ic:outline-email" class="ml-4" />
    </div>

    <div v-if="contacts" class="mt-4 space-y-3" data-testid="contacts-list">
      <BaseItem
        v-for="contact in contacts"
        :key="contact.id + contact.label"
        fallback="-"
        v-bind="contact"
        truncate
      />
    </div>

    <a
      v-if="linkUrl"
      class="mt-4 block text-primary-8"
      :href="linkUrl"
      target="_blank"
      rel="noopener"
    >
      {{ linkText }}
    </a>
    <p v-else class="mt-4 block" :class="{ 'text-loading': loading }">
      {{ linkText }}
    </p>
  </div>
</template>
